import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { Drawer,message,Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker,Select,Modal,   } from 'antd';
import { EditOutlined,PlusOutlined,DeleteOutlined,MoreOutlined } from '@ant-design/icons' ;
import $ from 'jquery';
import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';
import add from '../../assets/images/icon/add.png';
import edit from '../../assets/images/icon/edit.png';
import boy from '../../assets/images/icon/boy.png';
import girl from '../../assets/images/icon/girl.png';

const { TextArea } = Input;
const { Panel } = Collapse;
const { Option } = Select;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			school_list : [],
			timetable_details : [],
			periods : [],
			timetable_details : [],
			timeline_details : [],
			marketing_followup_details : [],
			visible: false,
			visible1: false,
			followup: false,
			addfollow: false,
			status_view: false,
			timeline: false,
			tab: 'Monday',
			week_days: [],
			start_time: '',
			end_time: '',
			type: '',
			name: '',
			duration: '',
			mobile_child: '',
		}
		this.change_type = this.change_type.bind(this);
		this.change_days = this.change_days.bind(this);
		this.onChangeStartTime = this.onChangeStartTime.bind(this);
		this.onChangeEndTime = this.onChangeEndTime.bind(this);
		this.change_price = this.change_price.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}
	
	showDrawer = () => {
		this.setState({
		  mobile_child: true,
		});
	  };
	 
	onClose = () => {
		this.setState({
		  mobile_child: false,
		});
	  }; 

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'],school_id : storedArray['data'][0]['school_id'] });
		
		}
		this.checkData()
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			 this.setState({ user_id : storedArray['data'][0]['user_id'] });
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			var days = this.state.tab;
			var app = {user_id : user_id,school_id:school_id,days:days,id:this.props.match.params.id}
			getData('Timetable/timetable_details',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							timetable_details: result['data'],
							
						});
					}else{
						this.setState({
							timetable_details: [],
							
						});
					}
				}
			});
	}
  }
	
	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
	  };
	  
	 handletabchange=(e)=>{
			this.setState({
					tab: e,
				});
			setTimeout(() => {
				this.checkData();
			}, 20);	
			
	} 
	
	showModal = () => {
		this.setState({
		  visible: false,
		});
		var id = '1';
		document.getElementById('open_action_' + id).classList.remove('is-active');
		this.setState({
		  visible: true,
		});
  };

  handleOk = e => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };

  handleCancel = e => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };
  
  showModal1 = () => {
    this.setState({
      visible1: true,
    });
  };

  handleOk1 = e => {
    console.log(e);
    this.setState({
      visible1: false,
    });
  };

  handleCancel1 = e => {
    console.log(e);
    this.setState({
      visible1: false,
    });
  };
  
  showMenu= (id, e) =>  {
		e.preventDefault();
		this.setState({
		  showMenu: 0,
		});		
		 var elems = document.querySelectorAll(".invoice-action .is-active");
		  [].forEach.call(elems, function(el) {
			el.classList.remove("is-active");
		  });
		setTimeout(() => {
			if(this.state.showMenu == 1){
			document.getElementById('open_action_' + id).classList.remove('is-active');
				this.setState({
				  showMenu: 0,
				});
			}else{
				document.getElementById('open_action_' + id).classList.add('is-active');
				this.setState({
				  showMenu: 1,
				});
			}
		}, 200);	
		
		
		
	}
	
	change_days(event){
         this.setState({week_days: event});
     }
	 change_type(event){
         this.setState({type: event});
     }
	
	onChangeStartTime(time, timeString) {
	 this.setState({ start_time: timeString, });
	}
	
	onChangeEndTime(time, timeString) {
	 this.setState({ end_time: timeString });
	}
	
	change_price() {
		var valuestart = this.state.start_time;
		var valuestop =  this.state.end_time;
		var hourDiff = valuestop - valuestart; 
		$('#time').html(hourDiff);   
	  }
	  
	handleSubmit=(e)=>{
		e.preventDefault();
		if(localStorage.getItem('schoolData')){
		this.setState({ loading: true });
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		
		
		
		var app = {
			
			school_id : storedArray['data'][0]['school_id'],
			user_id : storedArray['data'][0]['user_id'],
			id : this.props.match.params.id,
			start_time : this.state.start_time,
			end_time : this.state.end_time,
			start_time : this.state.start_time,
			days : this.state.week_days,
			name : this.state.name,
			duration : this.state.duration,
			type : this.state.type,
			
		}
		getData('Timetable/add_periods',app).then((result) => {
		if(result.status==400){
             message.config({ top: 150});
			message.error('Please Insert All Field',2);
			this.setState({ loading: false });
          }
          if(result.status==200){
            message.config({ top: 150});
            message.success('Timetable Updated',2);
              this.setState({ loading: false,visible1:false,mobile_child:false });
              this.setState({comment_text:''});
              setTimeout(() => {
					this.checkData();
				}, 20);
          }
      });
	  }else{
		message.error('Please Login',2);	
	  }

   }
   
   handledelete=(e)=>{
		
		var app = {
			user_id : this.state.user_id,
			school_id : this.state.school_id,
			id : e,
		}
		
		getData('Timetable/delete_timetable_period',app).then((result) => {
			if(result.status==200){
				message.config({ top: 150});
				message.success('Deleted Successfull',2);
				setTimeout(() => {
					this.checkData()
				}, 30);
				
			}
		});
	 

	}

	render()

	{
	var lenght = this.state.school_list.length; 
	const { size } = this.state;
	const content = (
					  <div>
						<p className="center upload-img"><Tooltip placement="right" title="Audio"><img src={music} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Pdf"><img src={pdf_} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Image"><img src={image} class="" alt="image" /></Tooltip></p>
						
					  </div>
					);
	const radioStyle = {
		  display: 'block',
		  height: '30px',
		  lineHeight: '30px',
		};				
					
		return (
			<div class="mobile_view">
			
			<div id="main" class="bg-off">
         <div class="row">
		{this.state.timetable_details.map((data)=> (	
			<>		
		 <div class="col s12 m12 ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="">
                  <div class="row no-margin">
				  <div class="col s12 m12 header-title mt-20 mh-40 iq-card">
                     
					 <div class="col s12 m6 l6 pb-15 mt-5">
                        <h5 class="breadcrumbs-title"><span class="back_arrow" onClick={this.context.router.history.goBack}><i class="ri-arrow-left-circle-line"></i></span><span class="main_title">Edit Time Table</span></h5>
                     </div>
                     <div class="col s12 m6 l6 right-align-md pt-10">
                      <ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li>
									   <li class="breadcrumb-item"><a href="/time-table/list">Time Table</a></li>
                           <li class="breadcrumb-item active">Edit Time Table
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            </div>
		 	
           
		   <div class="col s12 m12 ex-padd view-Profile view-Profile-mobile"> 
            <div class="container">
			   <div class="col s12 m12 mb-20  mh-500 no-padd">
                  <section class="section food no-padd">
					<div class="children mb-20 mh-40 time-table">
                    
						
						<div class="desktop-view">
							<div class=" row">
								<div class="col m12">
									<div class="col-md-4 left">
										<h6><b>Academic Year : </b>{data.academic_year}</h6>
									</div>
									<div class="col-md-4 left">
										<h6><b>Class : </b>{data.class_name}</h6>
									</div>
									
								</div>
							</div>
							<div class="row center">
								<Button className={`snd-btn staff untag ${this.state.tab == 'Monday'?'':'bg-color-none hover-none'}`} onClick={this.handletabchange.bind(this,'Monday')} >Monday</Button>
								
								<Button className={`snd-btn staff untag ${this.state.tab == 'Tuesday'?'':'bg-color-none hover-none'}`} onClick={this.handletabchange.bind(this,'Tuesday')}>Tuesday</Button>
								
								<Button className={`snd-btn staff untag ${this.state.tab == 'Wednesday'?'':'bg-color-none hover-none'}`} onClick={this.handletabchange.bind(this,'Wednesday')}>Wednesday</Button>
								
								<Button className={`snd-btn staff untag ${this.state.tab == 'Thursday'?'':'bg-color-none hover-none'}`} onClick={this.handletabchange.bind(this, 'Thursday')}>Thursday</Button>
								
								<Button className={`snd-btn staff untag ${this.state.tab == 'Friday'?'':'bg-color-none hover-none'}`} onClick={this.handletabchange.bind(this,'Friday')}>Friday</Button>
								
								<Button className={`snd-btn staff untag ${this.state.tab == 'Saturday'?'':'bg-color-none hover-none'}`} onClick={this.handletabchange.bind(this,'Saturday')}>Saturday</Button>
							</div>
							
							<div class="actions action-btns display-block align-items-center col col-md-12  right hidden-xs no-padd">
								
									 <button className="action_btn mt-5 right" onClick={this.showModal1}><PlusOutlined /> Add</button>
								
							</div>
							
							<div class="col m12 s12 ">
								<table class="cust_table">
									<thead>
										<tr>
											<th>Sr No.</th>
											<th>Period</th>
											<th>Start Time</th>
											<th>End Time</th>
											<th>Duration</th>
											<th>Action</th>
										</tr>
									</thead>
									<tbody>
									{data.periods.map((list) => (
										<tr>
											<td>{list.sr_no}</td>
											<td>{list.period_name}</td>
											<td>{list.start_time}</td>
											<td>{list.end_time}</td>
											<td>{list.duration}</td>
											<td>
											<div class="invoice-action">
												<button class="action-btn pl-10" onClick={this.showMenu.bind(this,list.period_timing_id)}>
												  <MoreOutlined />
												</button>
												<div className="action-menu" id={`open_action_${list.period_timing_id}`}>
													<Link to={`${process.env.PUBLIC_URL}/time-table/period-edit/${list.timetable_id}/${list.period_timing_id}`}><li> <EditOutlined />View & Edit </li></Link>
													
													<li onClick={this.handledelete.bind(this,list.period_timing_id)}><DeleteOutlined /> Delete</li>
													
												</div>
											</div>	
											</td>
										</tr>
										))}
										{(() => {  
										if (data.periods.length =='0') {
												return (
												<td id="error" class="center" colspan="6">No Data Found</td>
														)
													}
												})()}
										
									</tbody>
								</table>
							</div>
						</div>
						<div class="mobile-view">
						
							<div class="col s12 m12 ex-padd ">
								<div id="main" class="bg-off">
									<div class="row">
									<div class="container">
										
										<div class="mobile-tab">
											
											<div className={`mobile-tab-view ${this.state.tab == 'Monday' ?'':'tab-none'} `} onClick={this.handletabchange.bind(this,'Monday')} >
											Monday</div>	
											
											<div className={`mobile-tab-view ${this.state.tab == 'Tuesday' ?'':'tab-none'} `} onClick={this.handletabchange.bind(this,'Tuesday')} >
											Tuesday</div>
											
											<div className={`mobile-tab-view ${this.state.tab == 'Wednesday' ?'':'tab-none'} `} onClick={this.handletabchange.bind(this,'Wednesday')} >
											Wednesday</div>
											
											<div className={`mobile-tab-view ${this.state.tab == 'Thursday' ?'':'tab-none'} `} onClick={this.handletabchange.bind(this,'Thursday')} >
											Thursday</div>
											
											<div className={`mobile-tab-view ${this.state.tab == 'Friday' ?'':'tab-none'} `} onClick={this.handletabchange.bind(this,'Friday')} >
											Friday</div>
											
											<div className={`mobile-tab-view ${this.state.tab == 'Saturday' ?'':'tab-none'} `} onClick={this.handletabchange.bind(this,'Saturday')} >
											Saturday</div>
											
											</div>
										
									</div>
									</div>
								</div>
							</div>
							<div class="mt-50">	
								<div class="children bg-blue tags iq-card2 flow-root">
												{data.periods.map((list) => (
												
												<div class="col m12 s12 mb-10 bb pb-10 tag-div">
														<div class="col m10 s12 ">
															<span class="fw-4">Period Name</span> {list.period_name}<br/>
															<span class="fw-4">Timing</span> {list.start_time} - {list.end_time}<br/>
															<span class="fw-4">Duration</span> {list.duration}<br/>
														</div>
														
												</div>
												
												))}
												
												{(() => {  
													if (data.periods.length =='0') {
														return (
															<td id="error" class="center mt-20" colspan="6">No Data Found</td>
														)
													}
												})()}	
								</div>
							</div>
							<div class="notice-left">
								<p onClick={this.showDrawer} ><img src={add} /></p>
							</div>
							
						</div>	
						
						
						
						
						
					</div> 
					
					<Modal
					  title="Edit Time Table"
					  visible={this.state.visible}
					  onOk={this.handleOk}
					  onCancel={this.handleCancel}
					  className="view-Profile tt-modal"
					>
							<div class="col m6 s6 mb-10 dis-input row">
									<div class="col m4 s4 dis-input">
										<label class="d-block"><b>Period Name :</b></label>
									</div>	
									<div class="col m8 s8 dis-input">	
										<label><b>Period 1</b></label>
									</div>
							</div>
							<div class="col m6 s6 mb-20 dis-input row">
									<div class="col m4 s4 dis-input">
										<label><b>Select Days :</b></label>
									</div>		
									<div class="col m8 s8 dis-input">	
										<Select onChange={this.change_label} allowClear mode="multiple">
											<Select.Option value="Monday">Monday</Select.Option>
											<Select.Option value="Tuesday">Tuesday</Select.Option>
											<Select.Option value="Wednesday">Wednesday</Select.Option>
											<Select.Option value="Thursday">Thursday</Select.Option>
											<Select.Option value="Friday">Friday</Select.Option>
											<Select.Option value="Saturday">Saturday</Select.Option>
										</Select>
									</div>	
							</div>
							<div class="col m6 s6 mb-20 mt-40 dis-input row">
									<div class="col m4 s4 dis-input">
										<label class="d-block"><b>Start Time :</b></label>
									</div>	
									<div class="col m8 s8 dis-input">
										<TimePicker use12Hours format="h:mm a" onChange={onChange} />
									</div>	
							</div>
							<div class="col m6 s6 mb-10 dis-input row">
									<div class="col m4 s4 dis-input">
										<label class="d-block"><b>End Time :</b></label>
									</div>		
									<div class="col m8 s8 dis-input">
										<TimePicker use12Hours format="h:mm a" onChange={onChange} />
									</div>		
							</div>
							<div class="col m6 s6 mb-10 dis-input row">
									<div class="col m4 s4 dis-input">
										<label class="d-block"><b>Duration :</b></label>
									</div>			
									<div class="col m8 s8 dis-input">	
										<label><b>15 Minutes</b></label>
									</div>			
							</div>
							<Button className="snd-btn mt-20" >Update</Button>
					  
					</Modal>
					
					<Modal
					  title="Add Time Table"
					  visible={this.state.visible1}
					  onOk={this.handleOk1}
					  onCancel={this.handleCancel1}
					  className="view-Profile tt-modal"
					>
							
							<div class="col m6 s6 mb-20 dis-input row">
									<div class="col m4 s4 dis-input">
										<label class="mt-10 d-block"><b>Select Type :</b></label>
									</div>		
									<div class="col m8 s8 dis-input">	
										<Select onChange={this.change_type}>
											<Select.Option value="period">Period</Select.Option>
											<Select.Option value="break">Break</Select.Option>
										</Select>
									</div>	
							</div>
							<div class="col m6 s6 mb-10 dis-input row">
									<div class="col m4 s4 dis-input">
										<label class="d-block mt-10"><b>Period Name :</b></label>
									</div>	
									<div class="col m8 s8 dis-input">	
										<input type="text" name="name" id="name" onChange={this.handleSizeChange} />
									</div>
							</div>
							<div class="col m6 s6 mb-20 dis-input row">
									<div class="col m4 s4 dis-input">
										<label class="mt-10 d-block"><b>Select Days :</b></label>
									</div>		
									<div class="col m8 s8 dis-input">	
										<Select onChange={this.change_days} allowClear mode="multiple">
											<Select.Option value="Monday">Monday</Select.Option>
											<Select.Option value="Tuesday">Tuesday</Select.Option>
											<Select.Option value="Wednesday">Wednesday</Select.Option>
											<Select.Option value="Thursday">Thursday</Select.Option>
											<Select.Option value="Friday">Friday</Select.Option>
											<Select.Option value="Saturday">Saturday</Select.Option>
										</Select>
									</div>	
							</div>
							<div class="col m6 s6 mb-20 mt-40 dis-input row">
									<div class="col m4 s4 dis-input">
										<label class="d-block mt-10"><b>Start Time :</b></label>
									</div>	
									<div class="col m8 s8 dis-input">
										<TimePicker use12Hours format="h:mm a" onChange={this.onChangeStartTime} />
									</div>	
							</div>
							<div class="col m6 s6 mb-10 dis-input row">
									<div class="col m4 s4 dis-input">
										<label class="d-block mt-10"><b>End Time :</b></label>
									</div>		
									<div class="col m8 s8 dis-input">
										<TimePicker use12Hours format="h:mm a" onKeyUp={this.change_price} onChange={this.onChangeEndTime} />
									</div>		
							</div>
							<div class="col m6 s6 mb-10 dis-input row">
									<div class="col m4 s4 dis-input">
										<label class="d-block mt-10"><b>Duration :</b></label>
									</div>			
									<div class="col m8 s8 dis-input">	
										<p name="time" class="time" id="time"><b></b></p>
									</div>			
							</div>
							<Button className="snd-btn mt-20" onClick={this.handleSubmit} loading={this.state.loading}>Add</Button>
					  
					</Modal>
					
					<Drawer
								  title="Add Time Table"
								  width="100%"
								  onClose={this.onClose}
								  visible={this.state.mobile_child}
								  bodyStyle={{ paddingBottom: 80 }}
								  className="select-child"
								>
								
									<div class="children bg-blue view-Profile attendance mt-10">
										<div class="col m6 s12 mb-10 dis-input row">
												<div class="col m4 s12 dis-input">
													<label class="mt-10 d-block"><b>Select Type :</b></label>
												</div>		
												<div class="col m8 s12 dis-input">	
													<Select onChange={this.change_type}>
														<Select.Option value="period">Period</Select.Option>
														<Select.Option value="break">Break</Select.Option>
													</Select>
												</div>	
										</div>
										<div class="col m6 s12 mb-10 dis-input row">
												<div class="col m4 s12 dis-input">
													<label class="d-block mt-10"><b>Period Name :</b></label>
												</div>	
												<div class="col m8 s12 dis-input">	
													<input type="text" name="name" id="name" onChange={this.handleSizeChange} />
												</div>
										</div>
										<div class="col m6 s12 mb-10 dis-input row">
												<div class="col m4 s12 dis-input">
													<label class="mt-10 d-block"><b>Select Days :</b></label>
												</div>		
												<div class="col m8 s12 dis-input">	
													<Select onChange={this.change_days} allowClear mode="multiple">
														<Select.Option value="Monday">Monday</Select.Option>
														<Select.Option value="Tuesday">Tuesday</Select.Option>
														<Select.Option value="Wednesday">Wednesday</Select.Option>
														<Select.Option value="Thursday">Thursday</Select.Option>
														<Select.Option value="Friday">Friday</Select.Option>
														<Select.Option value="Saturday">Saturday</Select.Option>
													</Select>
												</div>	
										</div>
										<div class="col m6 s12 mb-10 dis-input row">
												<div class="col m4 s12dis-input">
													<label class="d-block mt-10"><b>Start Time :</b></label>
												</div>	
												<div class="col m8 s12 dis-input">
													<TimePicker use12Hours format="h:mm a" onChange={this.onChangeStartTime} />
												</div>	
										</div>
										<div class="col m6 s12 mb-10 dis-input row">
												<div class="col m4 s12 dis-input">
													<label class="d-block mt-10"><b>End Time :</b></label>
												</div>		
												<div class="col m8 s12 dis-input">
													<TimePicker use12Hours format="h:mm a" onKeyUp={this.change_price} onChange={this.onChangeEndTime} />
												</div>		
										</div>
										<div class="col m6 s12 mb-10 dis-input row">
												<div class="col m4 s12 dis-input">
													<label class="d-block mt-10"><b>Duration :</b></label>
												</div>			
												<div class="col m8 s12 dis-input">	
													<p name="time" class="time" id="time"><b></b></p>
												</div>			
										</div>	   
										   
										
									</div>
								
									<div className="fix-foter">
										 
										 <Button onClick={this.handleSubmit} loading={this.state.loading} type="primary">
											Done
										 </Button>
									</div>
								  
								</Drawer>
					
					
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
			</>
			))}
			
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
